<template>
  <td>
    <component
      :is="renderComponent"
      class="mr-1"
      v-for="link in links"
      :key="link"
      :href="'/dialogkontrolle/' + link"
      :to="'/dialogkontrolle/' + link"
    >
      {{ link }}
    </component>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
        renderComponent() {
            if (!this.$route) {
              return "a";
            } else {
              return "router-link";
            }
        },
        links() {
          if (Array.isArray(this.content)) {
              return this.content;
          } else {
              return [this.content];
          }
        }
    }
};
</script>
